module.exports = __webpack_public_path__ + "img/ic_prev_customer.469a0fde.svg";